import { SearchViewStateRecord } from '@common/data-models/records/search-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { GlobalTablesService } from "@common/services/global-tables-service";

export class DraftSearchViewStateRecord extends SearchViewStateRecord {

    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.DRAFTSEARCH;
    }
}
